/**
 *
 * Asynchronously loads the component for Men005
 * Author: LanVt
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
